var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "wscn-http404-container" }, [
      _c("div", { staticClass: "wscn-http404" }, [
        _c("div", { staticClass: "pic-404" }),
        _vm._v(" "),
        _c("div", { staticClass: "bullshit" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }